import { ILocalStorageProvider } from '@innosonian/brayden-core/build/src/_localStorage/localStorage.interface'

const localStorageProvider: ILocalStorageProvider = {
    removeItem: (str: string) => localStorage.removeItem(str),
    getItem: (str: string) => localStorage.getItem(str),
    setItem: (str: string, value: string) => localStorage.setItem(str, value),
}

export default localStorageProvider
